import { nFormatter } from "utils/parseNumber";

import { ReactComponent as ImageIcon } from "components/icons/Eye_Show.svg";
import { ReactComponent as VideoIcon } from "components/icons/playIcon.svg";
import { ReactComponent as SearchIcon } from "components/icons/search.svg";

import "./buttons.scss";

export enum ViewsButtonType {
  VIDEO = 1,
  IMAGE = 2,
  SEARCH = 3
}

export const ViewsButton = (props: {
  count: number;
  onClick?: () => void;
  type?: ViewsButtonType;
}): JSX.Element => {

  const renderIconUrl = () => {
    const { IMAGE, SEARCH } = ViewsButtonType;

    if (props.type === IMAGE) {
      return <ImageIcon />;
    }

    if (props.type === SEARCH) {
      return <SearchIcon />;
    }

    return <VideoIcon />;
  };

  const onClick = () => {
    props.onClick && props.onClick();
  };

  return (
    <button
      className="rg-button views icon"
      onClick={onClick}
    >
      {renderIconUrl()}
      <div className="label">{nFormatter(props.count)}</div>
    </button>
  );
};
